import { useState } from "react";
import QuestionBox from "../../ui/QuestionBox/QuestionBox";
import RadioButton from "../../ui/RadioButton/RadioButton";
import classes from "../Infrastructure/Infrastructure.module.css";
import CommonFooter from "../../CommonFooter/CommonFooter";
import CommonButton from "../../ui/CommonButton/CommonButton";
import { useAuth } from "../../../context/AuthContext";
import { useParams } from "react-router-dom";
import { useQuestionnaire } from "../../../hooks/useQuestionnaire";

const initialState = {
  hasSupplyChainSystem: "",
  hasLogisticsOfficer: "",
  hasStoreRoom: "",
  isLogisticsOfficerTrained: "",
  hasReagentRefrigerators: "",
};

const LogisticsSupplyChain = () => {

  const {
      formData,
      handleChange,
      handleDone,
      editMode,
      setEditMode,
      isReadOnly,
      isFetching,
      loading,
      isOffline,
    } = useQuestionnaire("logistics-supply", initialState);

  const [currentSet, setCurrentSet] = useState(0);

  const { user } = useAuth();
  const { labId: paramLabId } = useParams();
  const labId = paramLabId || user?.labId;

  const userRole = user?.role;

  

  // ----------------------------------
  // UI Questions
  // ----------------------------------
  const questionSets = [
    {
      content: (
        <div className="d-flex flex-column gap-4">
          <QuestionBox
            number={1}
            question="Is there a system for supply Chain Management, eLMIS?"
            disabled={isReadOnly}
          >
            <div className="d-flex gap-2 mb-4">
              <RadioButton
                label="Yes"
                name="hasSupplyChainSystem"
                checked={formData.hasSupplyChainSystem === "Yes"}
                onChange={() => handleChange("hasSupplyChainSystem", "Yes")}
                disabled={isReadOnly}
              />
              <RadioButton
                label="No"
                name="hasSupplyChainSystem"
                checked={formData.hasSupplyChainSystem === "No"}
                onChange={() => handleChange("hasSupplyChainSystem", "No")}
                disabled={isReadOnly}
              />
            </div>
          </QuestionBox>

          <QuestionBox
            number={2}
            question="Does the Laboratory have a store Room for reagent and consumable storage?"
            disabled={isReadOnly}
          >
            <div className="d-flex gap-2 mb-4">
              <RadioButton
                label="Yes"
                name="hasStoreRoom"
                checked={formData.hasStoreRoom === "Yes"}
                onChange={() => handleChange("hasStoreRoom", "Yes")}
                disabled={isReadOnly}
              />
              <RadioButton
                label="No"
                name="hasStoreRoom"
                checked={formData.hasStoreRoom === "No"}
                onChange={() => handleChange("hasStoreRoom", "No")}
                disabled={isReadOnly}
              />
            </div>
          </QuestionBox>

          <QuestionBox
            number={3}
            question="Is there a Logistics Officer?"
            disabled={isReadOnly}
          >
            <div className="d-flex gap-2 mb-2">
              <RadioButton
                label="Yes"
                name="hasLogisticsOfficer"
                checked={formData.hasLogisticsOfficer === "Yes"}
                onChange={() => handleChange("hasLogisticsOfficer", "Yes")}
                disabled={isReadOnly}
              />
              <RadioButton
                label="No"
                name="hasLogisticsOfficer"
                checked={formData.hasLogisticsOfficer === "No"}
                onChange={() => handleChange("hasLogisticsOfficer", "No")}
                disabled={isReadOnly}
              />
            </div>
          </QuestionBox>

          <QuestionBox
            number={4}
            question="Is the Logistics Officer trained?"
            disabled={isReadOnly}
          >
            <div className="d-flex gap-2 mb-2">
              <RadioButton
                label="Yes"
                name="isLogisticsOfficerTrained"
                checked={formData.isLogisticsOfficerTrained === "Yes"}
                onChange={() =>
                  handleChange("isLogisticsOfficerTrained", "Yes")
                }
                disabled={isReadOnly}
              />
              <RadioButton
                label="No"
                name="isLogisticsOfficerTrained"
                checked={formData.isLogisticsOfficerTrained === "No"}
                onChange={() => handleChange("isLogisticsOfficerTrained", "No")}
                disabled={isReadOnly}
              />
            </div>
          </QuestionBox>

          <QuestionBox
            number={5}
            question="Does the Laboratory have Refrigerators specifically for laboratory reagent storage?"
            disabled={isReadOnly}
          >
            <div className="d-flex gap-2 mb-2">
              <RadioButton
                label="Yes"
                name="hasReagentRefrigerators"
                checked={formData.hasReagentRefrigerators === "Yes"}
                onChange={() => handleChange("hasReagentRefrigerators", "Yes")}
                disabled={isReadOnly}
              />
              <RadioButton
                label="No"
                name="hasReagentRefrigerators"
                checked={formData.hasReagentRefrigerators === "No"}
                onChange={() => handleChange("hasReagentRefrigerators", "No")}
                disabled={isReadOnly}
              />
            </div>
          </QuestionBox>
        </div>
      ),
    },
  ];

  if (isFetching) return <div className={classes.loading}>Loading...</div>;

  return (
    <div
      className={`${classes.wrapper} ${paramLabId ? classes.fromParams : ""} ${
        isReadOnly ? classes.readOnly : ""
      }`}
    >
      <div className="d-flex justify-content-between align-items-center">
        <h2>Logistics and supply chain management</h2>

        {userRole === "LABORATORY" && !editMode && (
          <CommonButton
            className={classes.editButton}
            onClick={() => setEditMode(true)}
            title="Edit"
          />
        )}
      </div>

      {!editMode && userRole !== "MINISTRY" ? (
        <div className={classes.infoText}>
          ✅ Your Logistics & Supply Chain section has been submitted.
        </div>
      ) : (
        questionSets[currentSet].content
      )}

      {!isReadOnly && (
        <CommonFooter
          handlePrevious={() => currentSet > 0 && setCurrentSet(currentSet - 1)}
          handleNext={() =>
            currentSet < questionSets.length - 1 &&
            setCurrentSet(currentSet + 1)
          }
          handleDone={handleDone}
          cancelText="Cancel"
          handleCancel={() => {
            setEditMode(false);
            setCurrentSet(0);
          }}
          questionSets={questionSets}
          currentSet={currentSet}
          disabled={loading}
          doneText={
            loading ? "Submitting..." : isOffline ? "Save Offline" : "Submit"
          }
        />
      )}
    </div>
  );
};

export default LogisticsSupplyChain;
